import { Component, OnInit, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { ApiService } from '../../../../../../Services/api.service';
import { StorageService } from '../../../../../../Services/storage.service';
import { SweetAlert } from '../../../../../../Services/sweetalet.service';
declare const Swal;

@Component({
  selector: 'app-assign-vehicle',
  templateUrl: './assign-vehicle-component.html',
  //   styleUrls: ['./view-manage-vehicle-driver.component.css']
})
export class AssignVehicleComponent implements OnInit {
  @Input() _activeMenu: string = '';
  @Input() enableSearch: boolean = true;
  @Input() public set search(val: string) {
    this.onSearchChange(val);
  }

  public vendorID = '';
  public manageData = [];

  public filterTable: boolean = true;
  public enableTable: boolean = false;
  isClicked: boolean = false;
  /* Pagination */
  public showPagination: boolean = true;
  public paginationData = {
    page: 1,
    limit: 10,
    totalPage: 1,
  };

  /* filters */
  searchChangeObserver: any;
  public searchInputValue = '';
  public branchNameMap: { [key: string]: string } = {};
  public vehicleBranchMap: { [key: string]: string } = {};

  public cols = [
    { key: '#', display: '#' },
    { key: 'vehRegNo', display: 'Reg no', config: { isVehicle: true, }, headerConfig: { isDefault: true } },
    { key: 'branch', display: 'Branch' },
    { key: 'model', display: 'Model', config: { isAttendance: true, }, },
    { key: 'driverName', display: 'Driver', headerConfig: { isDefault: true } },
    // { key: 'extraDrivers', display: 'Additional drivers', headerConfig: { isDefault: true } },
    {
      key: 'action', display: 'Action',
      config: {
        isAction: true,
        actions: [
          { display: 'Update', color: 'primary', icon: 'Edit', class: 'fs-13' },
          { display: 'Delete', color: 'warn', icon: 'Delete' },
        ]
      }
    }
  ];
  public assignvehicleValues = [];

  constructor(
    public storage: StorageService,
    public router: Router,
    public route: ActivatedRoute,
    public api: ApiService,
    public swal: SweetAlert,
  ) {
    this.route.paramMap.subscribe((params: any) => {
      this.vendorID = params.params.vendorID;
    });
  }

  ngOnInit(): void {
    this.getBranchList();
    this.getVehicleBranchList();
    if (!this.enableSearch) setTimeout(() => { this.getManageList(); }, 1000);
  }

  getBranchList() {
    const obj = {
      orgID: this.storage.get('userInfo').orgID
    };

    this.api.transportManagerBranchList(obj).then((res: any) => {
      if (res?.status === 'success' && Array.isArray(res.data)) {
        this.branchNameMap = {};
        res.data.forEach(branch => {
          if (branch?.branchID) {
            this.branchNameMap[String(branch.branchID)] = branch.branchName || branch.branchID;
          }
        });
        this.remapTableBranchValues();
      }
    }).catch((err) => {
      console.log(err);
    });
  }

  getVehicleBranchList() {
    const obj = {
      vendorID: this.vendorID == null ? this.storage.get('vendorID_orgID').vendorID : this.vendorID,
    };

    this.api.transportManagerVehicleList(obj).then((res: any) => {
      if (res?.status === 'success' && Array.isArray(res.data)) {
        this.vehicleBranchMap = {};
        res.data.forEach(vehicle => {
          if (vehicle?.vehRegNo) {
            this.vehicleBranchMap[String(vehicle.vehRegNo)] = this.formatBranchTokens(
              vehicle?.branchName ?? vehicle?.branch ?? vehicle?.branchID
            );
          }
        });
        this.remapTableBranchValues();
      }
    }).catch((err) => {
      console.log(err);
    });
  }

  normalizeList(value: any): any[] {
    if (value === null || value === undefined || value === '') {
      return [];
    }

    if (Array.isArray(value)) {
      return value;
    }

    if (typeof value === 'string' && value.includes(',')) {
      return value.split(',').map(item => item.trim()).filter(item => item !== '');
    }

    return [value];
  }

  extractBranchToken(branch: any): string {
    if (branch === null || branch === undefined) {
      return '';
    }

    if (typeof branch === 'object') {
      return String(
        branch.branchID ??
        branch.branch ??
        branch.branchName ??
        branch.value ??
        branch.name ??
        ''
      ).trim();
    }

    return String(branch).trim();
  }

  formatBranchTokens(rawBranches: any): string {
    const branches = this.normalizeList(rawBranches)
      .map(branch => {
        const key = this.extractBranchToken(branch);
        return this.branchNameMap[key] || key;
      })
      .filter(branch => branch && branch !== 'undefined' && branch !== 'null');

    return branches.length > 0 ? branches.join(', ') : '';
  }

  getDriverShiftBranch(item: any): string {
    if (!Array.isArray(item?.driverShift) || item.driverShift.length === 0) {
      return '';
    }

    for (const driver of item.driverShift) {
      const branchValue = this.formatBranchTokens(driver?.branchName ?? driver?.branch ?? driver?.branchID);
      if (branchValue) {
        return branchValue;
      }
    }

    return '';
  }

  formatBranchValue(item: any): string {
    const currentRowBranch = this.formatBranchTokens(item?.branchName ?? item?.branch ?? item?.branchID);
    if (currentRowBranch) {
      return currentRowBranch;
    }

    const vehicleBranch = item?.vehRegNo ? this.vehicleBranchMap[String(item.vehRegNo)] : '';
    if (vehicleBranch) {
      return vehicleBranch;
    }

    const driverBranch = this.getDriverShiftBranch(item);
    if (driverBranch) {
      return driverBranch;
    }

    return '---';
  }

  remapTableBranchValues() {
    if (!Array.isArray(this.assignvehicleValues) || this.assignvehicleValues.length === 0) {
      return;
    }

    this.assignvehicleValues = this.assignvehicleValues.map(item => ({
      ...item,
      branch: this.formatBranchValue(item)
    }));
  }

  getManageList(page = 1, limit = 10, vehRegNo?) {
    this.enableTable = false;
    const obj = {
      vendorID: this.vendorID == null ? this.storage.get('vendorID_orgID').vendorID : this.vendorID,
      page: page,
      limit: limit,
    };
    if (vehRegNo && vehRegNo != '') obj['vehRegNo'] = vehRegNo;

    this.api.transportManagerAssignedVehDriverList(obj).then((res: any) => {
      if (res.status == 'success') {
        if (res.data) {

          let vehilces = res.data.map((item) => {
            let obj = { ...item };
            if (obj.model && obj.model == 'loadVehicle') obj.model = 'Load Vehicle';
            return obj;
          })
          this.assignvehicleValues = this.addExtraDrivers(vehilces).map(item => ({
            ...item,
            branch: this.formatBranchValue(item)
          }));

        }
        this.processPagination(res, obj);
      }
      setTimeout(() => { this.enableTable = true; }, 200);
    }).catch((err) => {
      console.log(err);
    });


  }


  addExtraDrivers(data) {
    return data.map((item) => {
      if (Array.isArray(item?.driverShift) && item?.driverShift?.length > 0) {
        const driverName = item.driverShift.map(dri => dri?.driverName).join(", ");
        return { ...item, driverName: driverName };
      } else {
        return { ...item };
      }
    });
  }
  processPagination(data, req) {
    this.enableTable = false;
    this.paginationData = {
      page: req.page,
      limit: req.limit,
      totalPage: this.getTotalCount(data.totCnt, req.limit),
    }
    this.enableTable = true;
  }

  getTotalCount(total, limit) {
    let result: any = 1;
    if (total / limit > 0) {
      result = total / limit;
      if (total % limit > 0) result++;
    }
    return Math.floor(result);
  }

  pagination(data) {
    this.getManageList(data.page, data.limit, this.searchInputValue);
  }

  // search
  onSearchChange(searchValue: string) {

    searchValue = searchValue.trim().replace(/[^a-zA-Z0-9-_&, ]/g, '');

    if (!this.searchChangeObserver) {
      new Observable(observer => {
        this.searchChangeObserver = observer;
      }).pipe(debounceTime(500)) // wait 300ms after the last event before emitting last event
        .pipe(distinctUntilChanged()) // only emit if value is different from previous value
        .subscribe((term: any) => {
          // your code here
          this.searchInputValue = term;
          if (String(term).length == 0) this.getManageList(1, this.paginationData.limit, term);
          else if (String(term).length >= 2) this.getManageList(1, this.paginationData.limit, term);

        });
    }

    this.searchChangeObserver.next(searchValue);
  }

  onActionHandler(e: any) {
    const data = e.data;
    if (e.action.display.toLowerCase() == 'update') {

      this.router.navigate(['/organization/transport-manager/information/manage/edit-manage-vehicle', e.data.vendorID, e.data.vehicleID]);

    } else if (e.action.display.toLowerCase() == 'delete') {
      console.log(e);
      Swal.fire({
        title: 'Are you sure?',
        text: 'You want to delete this!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',//'#3085d6',
        //  cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.isConfirmed) {
          console.log('delete click');
          this.deleteVehicleDriverData(e);
        }
      });
    } else if (e.action.display.toLowerCase() == 'view') {
      this.router.navigate(['/organization/transport-manager/information/driver/single-view-driver', e.data.vendorID, e.data.driverID]);
    }
  }
  deleteVehicleDriverData(e?) {
    const obj = {
      vehRegNo: e.data.vehRegNo,
      vendorID: e.data.vendorID,
      driverID: e.data.driverID,
    };
    this.api.transportMangerManageVehicleDriverDelete(obj).then((res: any) => {
      if (res.status == 'success') {
        this.swal.swalFunction(res.status, res.status, res.message, 2000);
        this.enableTable = false;
        this.getManageList();
      } else {
        this.swal.swalFunction(res.status, res.status, res.message, 2000);
      }
    }).catch((err) => {
      console.log(err);
    });
  }
}
